import React, { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Card, CardContent, CircularProgress, Divider, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import { Page, Header } from 'components'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { useTipoExameService } from 'hooks/useTipoExameService'
import { Espelho } from 'components/Espelho'
import { setIdSecaoExame } from 'actions'
import useStyles from './styles'
import constants from 'utils/constants'
import { useAuth } from 'hooks/useAuth'

export const ListaSecoes = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()
  const dispatch = useDispatch()
  const tipoExameService = useTipoExameService()
  const idTipoExame = useSelector((state) => state.idsState.idExame)
  const [secoes, setSecoes] = useState(null)
  const [processandoSecoes, setProcessandoSecoes] = useState(false)
  const [isDeletarOpen, setIsDeletarOpen] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [idSecaoSelecionada, setIdSecaoSelecionada] = useState(null)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  const fetchSecoesDeTipoExame = useCallback(async () => {
    if (idTipoExame) {
      const response = await tipoExameService.listarSecoesDeTipoExameAsync(idTipoExame, setProcessandoSecoes)
      setSecoes(response)
    }
  }, [idTipoExame])

  useEffect(() => {
    fetchSecoesDeTipoExame()
  }, [fetchSecoesDeTipoExame])

  const handleClickEditarSecao = useCallback((idSecao) => {
    dispatch(setIdSecaoExame(idSecao))
    router.history.push('/exames/secao/editar')
  }, [])

  const handleClickCadastrarSecao = useCallback(() => {
    router.history.push('/exames/secao/cadastrar')
  }, [])

  const handleClickDeletarSecao = useCallback((idSecao) => {
    setIsDeletarOpen(true)
    setIdSecaoSelecionada(idSecao)
  }, [])

  const handleConfirmarDeletarSecao = useCallback(async () => {
    if (idSecaoSelecionada) {
      await tipoExameService.deletarSecaoTipoExame(idSecaoSelecionada, setProcessandoOperacao)
      fetchSecoesDeTipoExame()
      setIsDeletarOpen(false)
    }
  }, [idSecaoSelecionada, fetchSecoesDeTipoExame])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          {processandoSecoes ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <Grid container md={12} sm={12} xs={12}>
              <Grid item md={12} sm={12} xs={12}>
                <Typography variant='h5'>
                  <b>SEÇÕES DO DOCUMENTO</b>
                </Typography>
                <Divider style={{ marginTop: '3px' }} />
              </Grid>

              <Grid item container md={12} sm={12} xs={12} spacing={1} className={classes.fieldGroup}>
                <Grid item container md={12} sm={12} xs={12} justifyContent="space-between">
                  <Grid item />
                  <Grid item>
                    <Button variant="contained" color="secondary" onClick={handleClickCadastrarSecao}>
                      <AddIcon />
                      Cadastrar seção
                    </Button>
                  </Grid>
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <TableContainer>
                    <Table aria-label="collapsible table" size="small">
                      <TableHead>
                        <TableRow className={classes.tableHeader}>
                          <TableCell style={{ width: '30%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>TÍTULO</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>TEXTO DEFAULT</Typography>
                          </TableCell>
                          <TableCell />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {secoes?.length ? (
                          secoes.map((secao) => (
                            <TableRow className={classes.tableRow} style={{ width: '100%' }}>
                              <TableCell>{secao.titulo}</TableCell>
                              <TableCell>{secao.textoDefault.length > 100 ? `${secao.textoDefault.slice(0, 100)}...` : secao.textoDefault}</TableCell>
                              <TableCell style={{ width: '150px' }}>
                                <IconButton onClick={() => handleClickEditarSecao(secao.id)}>
                                  <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton onClick={() => handleClickDeletarSecao(secao.id)}>
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow className={classes.tableRow} style={{ width: '100%' }}>
                            <TableCell colSpan={3} style={{ textAlign: 'center', padding: '30px' }}>
                              <Typography>Nenhuma seção foi adicionada a este exame</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <Divider />
              </Grid>
              <Grid item container md={12} sm={12} xs={12} justifyContent="space-between" style={{ padding: '10px' }}>
                <Grid item>
                  <Button variant="contained" style={{backgroundColor: '#9E1A1A', color: '#FFFFFF'}} onClick={() => router.history.push('/exames')}>
                    Voltar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
      <Espelho aberto={isDeletarOpen} setAberto={setIsDeletarOpen} handleConfirmar={handleConfirmarDeletarSecao} processando={processandoOperacao} disabled={false} titulo="Confirmação de operação">
        <Typography>Deseja realmente excluir essa seção ? </Typography>
      </Espelho>
    </Page>
  )
}
